import { configuration } from "../config/configuration";

const config: any = configuration();

export const apiRoutes = {
    "unsubscribeURL": `${config.baseURL}/api/v1/unsubscribe`
};